<template>
    <div class="hris-profile w-full max-w-sm">
        <dl class="grid grid-cols-[auto_1fr] gap-x-4 gap-y-3 body-small w-full">
            <!-- Editable name. The fields are live because Personalization enables Next from the typed
                 value. Enter only finishes the edit, so it never submits and advances onboarding. -->
            <dt class="font-medium text-control-label">{{ t("onboarding.hrisProfile.nameLabel") }}</dt>
            <dd>
                <BaseEditableField
                    v-model="name"
                    :label="t('onboarding.personalization.nameLabel')"
                    submit-mode="blur"
                    size="compact"
                    live
                    class="w-full"
                    autocomplete="name"
                    @keydown.enter="keepEnterInField" />
            </dd>

            <!-- Editable role -->
            <dt class="font-medium text-control-label">{{ t("onboarding.hrisProfile.roleLabel") }}</dt>
            <dd>
                <BaseEditableField
                    v-model="role"
                    :label="t('onboarding.personalization.roleLabel')"
                    submit-mode="blur"
                    size="compact"
                    live
                    class="w-full"
                    autocomplete="organization-title"
                    @keydown.enter="keepEnterInField" />
            </dd>

            <!-- Read-only HRIS fields -->
            <template v-for="field in readOnlyFields" :key="field.key">
                <dt class="font-medium text-control-label">{{ field.label }}</dt>
                <dd class="text-ink-muted">{{ field.value }}</dd>
            </template>
        </dl>
    </div>
</template>

<script setup lang="ts">
import BaseEditableField from "~vue/components/form/BaseEditableField.vue";
import { unlessComposing } from "~vue/utils/keyboard";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps<{
    hrisData: { manager?: string | null; department?: string | null; hire_date?: string | null };
}>();

const name = defineModel<string>("name", { default: "" });
const role = defineModel<string>("role", { default: "" });

// A live field leaves Enter to the surrounding form; here the field ends the edit and the Enter stops.
const keepEnterInField = unlessComposing(() => {});

const readOnlyFields = computed(() => {
    const d = props.hrisData;
    return [
        { key: "manager", label: t("onboarding.hrisProfile.managerLabel"), value: d.manager },
        { key: "department", label: t("onboarding.hrisProfile.teamLabel"), value: d.department },
        { key: "hire_date", label: t("onboarding.hrisProfile.startDateLabel"), value: d.hire_date },
    ].filter((f) => f.value);
});
</script>

<style scoped>
@reference "../../../css/tailwind.css";
@layer components {
    .hris-profile {
        @apply rounded-2xl border border-border bg-surface-raised p-6 flex flex-col items-center;
    }
}
</style>
